import { useContext } from "react";
import { ConfigContext } from "../contexts/config";

export const useAppConfig = () => {
    return useContext(ConfigContext);
}